'use es6';

import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import PropTypes from 'prop-types';
import React from 'react';
import { warnIfFragment } from '../utils/devWarnings';
/**
 * Group clusters of Radio/Checkbox Buttons together, with common styling
 **/

export default function UIToggleGroup(props) {
  /* eslint-disable react/prop-types */
  var children = props.children,
      __error = props.error,
      inline = props.inline,
      name = props.name,
      rest = _objectWithoutProperties(props, ["children", "error", "inline", "name"]);

  return React.createElement("div", rest, React.Children.map(children, function (child) {
    warnIfFragment(child, UIToggleGroup.displayName);
    return child && child.type && React.cloneElement(child, Object.assign({
      inline: inline,
      name: name
    }, child.props));
  }));
}
UIToggleGroup.propTypes = {
  children: PropTypes.node.isRequired,
  inline: PropTypes.bool,
  name: PropTypes.string.isRequired
};
UIToggleGroup.displayName = 'UIToggleGroup';